import AbstractTokenStorage from "./AbstractTokenStorage";
import { DecodedJwt } from "@egis-auth/jwt-utils";

export default class MemoryTokenStorage<
  JwtType extends DecodedJwt = DecodedJwt
> extends AbstractTokenStorage<JwtType> {
  protected userToken: string | undefined = undefined;

  public getToken(): JwtType {
    if (!this.userToken) throw new Error("User token undefined");

    // Decodes token
    // /!\ Throws
    const decoded = this.decodeJwt(this.userToken);

    return decoded;
  }

  public getRawToken(): string {
    if (!this.userToken) throw new Error("User token undefined");

    return this.userToken;
  }

  public setToken(token: string): void {
    this.userToken = token;
  }

  public removeToken(): void {
    this.userToken = undefined;
  }
}
